import { computed, ref } from 'vue'

export type UiUpdateNotice = {
  id: string
  title: string
  description: string
  remoteVersion: string
  localVersion: string
  createTime: string
  isRead: boolean
}

const notice = ref<UiUpdateNotice | null>(null)

export function getUiUpdateNotice() {
  return notice
}

export const hasUiUpdateNotice = computed(() => Boolean(notice.value))

export function setUiUpdateNotice(payload: {
  remoteVersion: string
  localVersion: string
}) {
  const remoteLabel = String(payload.remoteVersion || '').trim() || '?'
  const localLabel = String(payload.localVersion || '').trim() || '?'
  notice.value = {
    id: `ui-update-${payload.remoteVersion}`,
    title: 'New UI version available',
    description: `You are on v ${localLabel}. Deployed build is v ${remoteLabel}. Refresh to load it — you stay signed in.`,
    remoteVersion: payload.remoteVersion,
    localVersion: payload.localVersion,
    createTime: new Date().toISOString(),
    isRead: false,
  }
}

export function clearUiUpdateNotice() {
  notice.value = null
}

export function markUiUpdateNoticeRead() {
  if (notice.value) notice.value = { ...notice.value, isRead: true }
}
